export default __webpack_public_path__ + "static/media/predictoin.0b6342e3.svg";